const processData = (malAssets, duration) => {
  if (!Array.isArray(malAssets) || malAssets.length === 0) return [];

  const now = new Date();
  const resultMap = {};
  let startDate = new Date(0);

  if (duration === "7") startDate.setDate(now.getDate() - 7);
  else if (duration === "30") startDate.setDate(now.getDate() - 30);

  malAssets.forEach((asset) => {
    const scanTime = new Date(asset.scan_time || asset.Date);    
    if (duration !== "all" && scanTime < startDate) return;
    
    const dateKey = scanTime.toISOString().split("T")[0];

    if (!resultMap[dateKey]) {
      resultMap[dateKey] = {
        date: dateKey,
        malicious: 0,
        suspicious: 0,
        harmless: 0,
      };
    }

    // Access counts from the status object
    const status = asset.status || {};
    
    // CHANGE: Sum the actual counts instead of just adding 1
    resultMap[dateKey].malicious += (status.malicious || 0);
    resultMap[dateKey].suspicious += (status.suspicious || 0);
    resultMap[dateKey].harmless += (status.harmless || 0);
  });

  return Object.values(resultMap).sort((a, b) => new Date(a.date) - new Date(b.date));
};

export { processData };
